export enum EVoucherType
{
    "none" = 0,
    "weekend" = 1,
    "weekDay" = 2
}
